module.exports = new __parcel__URL__("japanese_bg.381841d4.jpg").toString();